import * as React from "react";

interface MagnifyingIconProps {
  className?: string;
  onClick?: () => void;
}

export class MagnifyingIcon extends React.Component<MagnifyingIconProps> {
  render() {
    return (
      <div {...this.props} data-testid="magnifying-icon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 14.0311L10.4125 9.38106C11.0375 8.50918 11.4094 7.43731 11.4094 6.28106C11.4094 3.37168 9.075 1.00293 6.20625 1.00293C3.33438 0.999808 1 3.36856 1 6.27793C1 9.18731 3.33437 11.5561 6.20312 11.5561C7.44688 11.5561 8.5875 11.1123 9.48438 10.3717L14.0469 14.9998L15 14.0311ZM6.20312 10.3373C3.99688 10.3373 2.2 8.51543 2.2 6.27793C2.2 4.04043 3.99688 2.21856 6.20312 2.21856C8.40938 2.21856 10.2063 4.04043 10.2063 6.27793C10.2063 8.51543 8.4125 10.3373 6.20312 10.3373Z" fill="#333333" />
        </svg>
      </div>
    );
  }
}
